module.exports = __webpack_public_path__ + "img/Image_logo_12.36422c8e.jpg";